import React, { useCallback, useEffect, useState } from 'react';
import Connect from '@store/connect';
import axios from 'axios';
import dayjs from 'dayjs';
import './index.scss';

const SelfResult = () => {
    const [items, setItems] = useState([]);
    const init = useCallback(async () => {
        const ciphertext = sessionStorage.getItem('ciphertext');
        const res = await axios.post('/api/bid/item', {
            ciphertext,
        });

        if (res.data.status) {
            setItems(res.data.data);
        }
    }, []);
    useEffect(() => {
        init();
    }, []);

    return (
      <>
        <div className="header">招投标(采购)审核结果</div>
        {items.map((v, i) => {
                if (v.bid_status === 0) {
                    // 审核拒绝
                    return (
                      <div className="result-card" key={`${i}`}>
                        <div className="item">
                          <div className="title">投标人</div>
                          <div className="desc">{v.bid_user}</div>
                        </div>
                        <div className="item">
                          <div className="title">提交时间</div>
                          <div className="desc">
                            {dayjs(v.create_time).format(
                                        'YYYY-MM-DD HH:mm'
                                    )}
                          </div>
                        </div>
                        <div className="item">
                          <div className="title">投标项目</div>
                          <div className="desc">{v.task_name}</div>
                        </div>
                        <div className="item">
                          <div className="title">状态</div>
                          <div className="desc warn">审核拒绝</div>
                        </div>
                        <div className="item">
                          <div className="title">原因</div>
                          <div className="desc warn">
                            {v.reject_reason}
                          </div>
                        </div>
                        <div className="item">
                          <div className="title">提示</div>
                          <div className="desc warn">
                                    请按照拒绝原因，在详情页重新提交，如已经缴费则无需重复缴费
                          </div>
                        </div>
                      </div>
                    );
                } else if (v.bid_status === 1) {
                    // 审核通过
                    return (
                      <div className="result-card" key={`${i}`}>
                        <div className="item">
                          <div className="title">投标人</div>
                          <div className="desc">{v.bid_user}</div>
                        </div>
                        <div className="item">
                          <div className="title">提交时间</div>
                          <div className="desc">
                            {dayjs(v.create_time).format(
                                        'YYYY-MM-DD HH:mm'
                                    )}
                          </div>
                        </div>
                        <div className="item">
                          <div className="title">投标项目</div>
                          <div className="desc">{v.task_name}</div>
                        </div>
                        <div className="item">
                          <div className="title">状态</div>
                          <div className="desc pass">审核通过</div>
                        </div>
                        <div className="item">
                          <div className="title">招标文件</div>
                          {v.task_by_email !== 1 && (
                            <a
                                        href={v.file_location}
                                        onClick={async () =>
                                            await axios.get(
                                                `/api/bid/download?id=${v.id}`
                                            )
                                        }
                                    >
                                        下载
                            </a>
                                )}
                          {v.task_by_email === 1 && (
                            <div className="desc warn">
                                        招标(采购)文件将发送至各投标人(供应商)邮箱
                            </div>
                                )}
                        </div>
                      </div>
                    );
                } else {
                    // 未审核
                    return (
                      <div className="result-card" key={`${i}`}>
                        <div className="item">
                          <div className="title">投标人</div>
                          <div className="desc">{v.bid_user}</div>
                        </div>
                        <div className="item">
                          <div className="title">提交时间</div>
                          <div className="desc">
                            {dayjs(v.create_time).format(
                                        'YYYY-MM-DD HH:mm'
                                    )}
                          </div>
                        </div>
                        <div className="item">
                          <div className="title">投标项目</div>
                          <div className="desc">{v.task_name}</div>
                        </div>
                        <div className="item">
                          <div className="title">状态</div>
                          <div className="desc normal">等待审核</div>
                        </div>
                      </div>
                    );
                }
            })}
      </>
    );
};

SelfResult.propTypes = {};

const mapStateToProps = () => {};

export default Connect(mapStateToProps)(SelfResult);
